import React from 'react';
import cn from 'classnames';

import Logo from 'shared/ui/icons/General/Logo';
import HintQuestion from 'shared/ui/Hint/HintQuestion';
import {ITariff} from 'entities/tariff';

import {t} from '@lingui/core/macro';

import {PALETTE} from 'shared/config/model/palette';

import styles from './TariffLabel.module.scss';

interface TariffLabelProps {
    isActive: boolean;
    tariff: ITariff;
    days: string | undefined;
}

const TariffLabel: React.FC<TariffLabelProps> = ({ isActive, tariff, days }) => {

    const daysLeft = tariff.price > 0 && days ? t`: осталось ${days}` : '';

    if (tariff.is_archive) {
        return (
            <div className={cn(styles.label, styles.labelArchive)}>
                <span>{t`Ваш тариф архивный`} {daysLeft}</span>
                {
                    tariff.price > 0 &&
                        <HintQuestion
                            className={styles.question}
                            color={PALETTE.colorWhite}
                        >
                            {t`Архивный тариф пропадет при смене на любой другой тариф, в том числе на \
базовый бесплатный, если окончится оплаченный период.`}
                        </HintQuestion>
                }
            </div>
        );
    }

    if (isActive) {
        return (
            <div className={cn(styles.label, styles.labelActive)}>
                <span>{t`Ваш тариф`} {daysLeft}</span>
            </div>
        );
    }

    if (tariff.is_recommended) {
        return (
            <div className={cn(styles.label, styles.labelRecommended)}>
                <Logo />
                <span>{t`РЕКОМЕНДУЕТ`}</span>
            </div>
        );
    }

    return (
        <div className={cn(styles.label, styles.labelRecommended)}>
            <Logo />
        </div>
    );
};

export default TariffLabel;
